import React from 'react';
import Routes from './src/routes';
import { View, StatusBar } from 'react-native';

export default function App(){
  return (
    <>
      <Routes />
      <View>
        <StatusBar barStyle='dark-content' backgroundColor='#f4f7fb'></StatusBar>
      </View>
    </>
  );
}
